import { render } from "./KeyboardF5.vue?vue&type=template&id=14b4d052"
import script from "./KeyboardF5.vue?vue&type=script&lang=js"
export * from "./KeyboardF5.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/KeyboardF5.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "14b4d052"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('14b4d052', __exports__)) {
    api.reload('14b4d052', __exports__)
  }
  
  module.hot.accept("./KeyboardF5.vue?vue&type=template&id=14b4d052", () => {
    api.rerender('14b4d052', render)
  })

}


export default __exports__